<template>
  <div class="summary-topup-phone">
    <table>
      <caption class="sr-only">{{ $t('view.component.topup.single.phoneBox.captionPhoneBox') }}</caption>
      <thead>
        <tr class="row">
          <th>{{ $t('view.component.topup.single.phoneBox.label1') }}</th>
          <th>{{ $t('view.component.topup.single.phoneBox.label2') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="row" v-for="(topup, topupIndex) in topups" :key="topupIndex">
          <td>{{ topup.phone | phone }}</td>
          <td>{{ topup.amount }} zł</td>
        </tr>
      </tbody>
      <tfoot v-if="topups.length > 1">
        <tr class="row">
          <td>{{ $t('view.component.topup.single.phoneBox.labelSum') }}</td>
          <td>{{ getTopupAmountSum() }} zł</td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  name: 'TopupSinglePartialTopupPhonesBox',
  props: {
    topups: {
      type: Array,
      required: true
    }
  },
  methods: {
    getTopupAmountSum () {
      return this.topups.reduce((acc, topup) => {
        return acc + topup.amount
      }, 0)
    }
  }
}
</script>

<style lang="scss" src="../../../assets/scss/components/_summary-topup-phones-box.scss"></style>
